/* Shkreli Watches · premium collections & search – progressive enhancement (every form and link works without JS).
   1 filter form: auto-apply, mobile drawer (<dialog>) with live result count, "find a value" in long lists
   2 client dial-colour row (current page only, used only when no dial-colour store filter exists)
   3 "Read more" for long collection descriptions
   4 sticky offset under the sticky site header (--at-header-h) */
(function () {
  'use strict';
  var KEY = 'at-coll-scroll';
  var d = document, de = d.documentElement;
  var mq = window.matchMedia ? window.matchMedia('(min-width: 750px)') : null;
  var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  var EASE = 'cubic-bezier(.2,.6,.2,1)';

  function saveScroll() {
    try { sessionStorage.setItem(KEY, JSON.stringify({ p: location.pathname, y: window.scrollY || 0 })); } catch (e) {}
  }
  function restoreScroll() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      sessionStorage.removeItem(KEY);
      var o = JSON.parse(raw);
      if (o && o.p === location.pathname && typeof o.y === 'number') window.scrollTo(0, o.y);
    } catch (e) {}
  }

  /* 4 · sticky offset: the toolbar / A–Z bar sit directly under the sticky header */
  var hdrTick = false;
  function headerOffset() {
    hdrTick = false;
    var h = d.querySelector('.site-header');
    if (!h) return;
    var b = Math.round(h.getBoundingClientRect().bottom);
    if (b < 0 || b > 200) b = 0;
    de.style.setProperty('--at-header-h', b + 'px');
  }
  function onScroll() { if (!hdrTick) { hdrTick = true; requestAnimationFrame(headerOffset); } }

  /* 3 · Read more (the clamp itself is CSS under html.js, decided server-side by text length – no layout shift) */
  function initClamp(root) {
    (root || d).querySelectorAll('[data-at-clamp-btn]').forEach(function (btn) {
      if (btn.__atClamp) return;
      btn.__atClamp = true;
      var box = d.getElementById(btn.getAttribute('aria-controls'));
      if (!box) return;
      btn.addEventListener('click', function () {
        var open = !box.classList.contains('is-open');
        box.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? btn.getAttribute('data-l-less') : btn.getAttribute('data-l-more');
      });
    });
  }

  /* 2 · client dial colour: filters the rendered grid (current page only), FLIP reflow, choice kept per collection */
  function initDial(root) {
    var bar = root.querySelector('[data-at-dial-bar]');
    var grid = root.querySelector('[data-at-dial-grid]');
    if (!bar || !grid || bar.__atDial) return;
    bar.__atDial = true;
    var chips = Array.prototype.slice.call(bar.querySelectorAll('[data-at-dial-key]'));
    var status = bar.querySelector('[data-at-dial-status]');
    var store = 'at-dial:' + location.pathname + location.search;

    function apply(key, animate) {
      var list = Array.prototype.slice.call(grid.children);
      var first = list.map(function (li) { return li.hidden ? null : li.getBoundingClientRect(); });
      var n = 0;
      list.forEach(function (li) {
        var band = li.hasAttribute('data-at-band');
        var keys = ' ' + (li.getAttribute('data-at-dial') || '') + ' ';
        var show = !key || (!band && keys.indexOf(' ' + key + ' ') > -1);
        li.hidden = !show;
        if (show && !band) n++;
      });
      chips.forEach(function (c) {
        var on = c.getAttribute('data-at-dial-key') === key;
        c.classList.toggle('is-active', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      grid.classList.toggle('is-dial-filtered', !!key);
      if (status && animate) {
        status.textContent = n === 1 ? (bar.getAttribute('data-l-one') || '') : (bar.getAttribute('data-l-many') || '').replace('%n', n);
      }
      if (!animate || (rm && rm.matches) || !grid.animate) return;
      list.forEach(function (li, i) {
        if (li.hidden) return;
        var last = li.getBoundingClientRect(), f = first[i];
        if (f) {
          var dx = f.left - last.left, dy = f.top - last.top;
          if (Math.abs(dx) > 0.5 || Math.abs(dy) > 0.5) {
            li.animate([{ transform: 'translate(' + dx + 'px,' + dy + 'px)' }, { transform: 'none' }], { duration: 420, easing: EASE });
          }
        } else {
          li.animate([{ opacity: 0, transform: 'translateY(12px)' }, { opacity: 1, transform: 'none' }], { duration: 360, easing: EASE });
        }
      });
    }

    bar.addEventListener('click', function (e) {
      var c = e.target.closest && e.target.closest('[data-at-dial-key]');
      if (!c) return;
      var k = c.getAttribute('data-at-dial-key') || '';
      if (k && c.classList.contains('is-active')) k = '';
      apply(k, true);
      try { sessionStorage.setItem(store, k); } catch (err) {}
    });

    var k0 = '';
    try { k0 = sessionStorage.getItem(store) || ''; } catch (err) {}
    if (k0 && chips.some(function (c) { return c.getAttribute('data-at-dial-key') === k0; })) apply(k0, false);
  }

  /* 1 · "find a value" inside long filter lists */
  function initFind(root) {
    root.querySelectorAll('[data-at-find]').forEach(function (input) {
      if (input.__atFind) return;
      input.__atFind = true;
      input.hidden = false;
      var set = input.parentNode.querySelector('fieldset');
      if (!set) return;
      var items = Array.prototype.slice.call(set.querySelectorAll('[data-at-find-item]'));
      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        items.forEach(function (it) {
          var t = (it.textContent || '').toLowerCase();
          it.hidden = !!q && t.indexOf(q) === -1 && !(it.querySelector('input') || {}).checked;
        });
      });
      input.addEventListener('keydown', function (e) { if (e.key === 'Enter') e.preventDefault(); });
    });
  }

  function init(root) {
    if (!root || root.__atColl) return;
    root.__atColl = true;
    root.classList.add('is-js');
    initDial(root);
    initFind(root);
    var form = root.querySelector('[data-at-filter-form]');
    if (!form) return;
    var sheet = root.querySelector('[data-at-sheet]');
    var sheetBody = root.querySelector('[data-at-sheet-body]');
    var opener = root.querySelector('[data-at-sheet-open]');
    var countEl = root.querySelector('[data-at-count]');
    var moved = [root.querySelector('[data-at-filters]'), root.querySelector('[data-at-sort]')].filter(Boolean);
    var marks = moved.map(function (el) {
      var c = d.createComment('at');
      el.parentNode.insertBefore(c, el);
      return c;
    });
    var timer, ctrl;

    function params() {
      var p = new URLSearchParams();
      new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') p.append(k, v); });
      return p;
    }
    function go() {
      saveScroll();
      var q = params().toString();
      window.location.href = form.getAttribute('action') + (q ? '?' + q : '');
    }
    function updateCount() {
      if (!countEl) return;
      var p = params();
      p.set('section_id', root.getAttribute('data-section-id'));
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      fetch(form.getAttribute('action') + '?' + p.toString(), ctrl ? { signal: ctrl.signal } : {})
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (h) { var m = h && h.match(/data-at-count-src="(\d+)"/); if (m) countEl.textContent = m[1]; })
        .catch(function () {});
    }

    form.addEventListener('change', function (e) {
      if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-at-find')) return;
      var price = e.target && e.target.type === 'number';
      clearTimeout(timer);
      if (sheet && sheet.open) { timer = setTimeout(updateCount, 250); return; }
      if (price) return; /* price fields apply with their button / Enter */
      timer = setTimeout(go, 250);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearTimeout(timer);
      go();
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.at-coll-active a, .at-coll-empty a, .at-sheet__foot a, .at-dial--server a');
      if (a) saveScroll();
    });

    root.addEventListener('toggle', function (e) {
      var t = e.target;
      if (!t || !t.matches || !t.matches('[data-at-filter]') || !t.open) return;
      if (sheet && sheet.contains(t)) return;
      root.querySelectorAll('[data-at-filter][open]').forEach(function (x) { if (x !== t) x.open = false; });
      var f = t.querySelector('[data-at-find]');
      if (f && mq && mq.matches) setTimeout(function () { f.focus(); }, 30);
    }, true);
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || (sheet && sheet.open)) return;
      var o = root.querySelector('[data-at-filter][open]');
      if (!o) return;
      o.open = false;
      var s = o.querySelector('summary');
      if (s) s.focus();
    });

    if (!sheet || !opener || typeof sheet.showModal !== 'function') return;
    function focusables() {
      return Array.prototype.filter.call(
        sheet.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([hidden]), select:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.getClientRects().length > 0 || el === d.activeElement; }
      );
    }
    function openSheet() {
      moved.forEach(function (el) { sheetBody.appendChild(el); });
      sheet.showModal();
      de.classList.add('at-sheet-open');
      de.style.overflow = 'hidden';
      var c = sheet.querySelector('[data-at-sheet-close]');
      if (c) c.focus();
    }
    function closeSheet() { if (sheet.open) sheet.close(); }
    opener.addEventListener('click', openSheet);
    sheet.querySelectorAll('[data-at-sheet-close]').forEach(function (b) { b.addEventListener('click', closeSheet); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(); });
    sheet.addEventListener('close', function () {
      moved.forEach(function (el, i) { marks[i].parentNode.insertBefore(el, marks[i].nextSibling); });
      de.classList.remove('at-sheet-open');
      de.style.overflow = '';
      opener.focus();
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    if (mq) {
      var onMq = function (ev) { if (ev.matches) closeSheet(); };
      mq.addEventListener ? mq.addEventListener('change', onMq) : mq.addListener(onMq);
    }
  }

  d.addEventListener('click', function (e) {
    d.querySelectorAll('[data-at-coll] [data-at-filter][open]').forEach(function (x) {
      if (x.closest('[data-at-sheet]')) return;
      if (!x.contains(e.target)) x.open = false;
    });
  });

  function boot() {
    d.querySelectorAll('[data-at-coll]').forEach(init);
    initClamp(d);
    headerOffset();
    restoreScroll();
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  d.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector('[data-at-coll]');
    if (r) init(r);
    initClamp(e.target);
  });
})();
